<template>
  <div id="DisposalInvoiceTemplate">
      <div :class="`loader${loaderClass}`" v-show="loading">
      </div>
      <div id="page-content-wrapper" class="admin-content-area">
          <template v-if="cantAccessPage === true">
              <div class="page-name">
                  <div class="page-title"> Warranty Registration Form</div>
                  <div class="btn-groups">
                      <button type="button" class="btn btn-tertiary" v-on:click="print()" >
                          <i class="fp-print"> </i> Print
                      </button>
                      <button type="button" class="btn btn-tertiary" v-on:click="downloadPdf()" >
                          <i class="fp-download"> </i> Download
                      </button>
                      <button type="button" class="btn btn-tertiary" v-on:click="backBtn()" >
                          <i class="fp-back"> </i> Back
                      </button>
                  </div>
              </div>
              <div class="container-fluid">
                  <div class="admin-page-content vehicle-registration-preview">
                      <div class="bg-white">
                          <div class="invoice-view-table" id="vehicle_registration_content">

                          </div>
                      </div>
                  </div>
              </div>
          </template>
          <template v-else-if="cantAccessPage === false">
              <div class="container-fluid">
                  <div class="bg-white text-center">
                      <h1>
                          Oops!</h1>
                      <h2>
                          403 </h2>
                      <div class="error-details">
                          Sorry!, You don't have permission to access this page.
                      </div>
                  </div>
              </div>
          </template>
          <template v-else>
              <loading-content></loading-content>
          </template>
          <app-footer></app-footer>
      </div>
  </div>
</template>
<script>
import Vue from 'vue';

import LoadingContent from "@/components/LoadingContent.vue";
import {commonMixins} from '../mixins/commonMixins';
import { contractMixins } from '../mixins/contractMixins';

Vue.component("loading-content", LoadingContent);

export default {
  name: "VehicleRegistrationFormPreview",
  metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Warranty Registration Form Preview | " +process.env.COPYRIGHT_NAME
  },
  components: {
      appFooter: () => import('@/components/Footer')
  },
  mixins: [commonMixins, contractMixins],
  data: () => ({
      invoiceArr:[],
      loading:false,
      permissions:[],
      cantAccessPage:"",
      vehicle_registration_id : 0,
      path:"",
      invoice_number:'',
      invoice_date:'',
      due_date:'',
      customer:'',
      terms:'',
      po_no:'',
      invoice_type:'',
      sub_total:'',
      tax_amount:'',
      total:'',
      invoiceItemsArr:[],
      cust_code:'',
      cust_name:'',

  }),
  watch:{
      permissions: function(permission){
          var self = this;
          permission.forEach(function (permissions) {
              if(permissions.name == 'add_vehicle_registration') { // todo need to update the permission
                  self.cantAccessPage = true;
              }
          });
          if(self.cantAccessPage == ''){
              self.cantAccessPage = false;
          }
      }
  },
  mounted: function() {
      var self = this;
      self.vehicle_registration_id = this.$route.params.id;
      self.getPermissions();
      self.previewForm();
      self.path = process.env.API +  "/images/logo.png";
  },
  methods : {
      backBtn(){
          var self = this;
          self.$router.push("/warrantyregistration/view/"+self.vehicle_registration_id);
      },
      downloadPdf() {
          var self = this;
          self.loading = true ;
          $.ajax({
              url: process.env.ROOT_API + "/vehicle-registration/download/"+self.vehicle_registration_id,
              type: "POST",
              data: {
                  vehicle_registration_id:self.vehicle_registration_id,
              },
              headers: {
                  'Accept': 'application/json',
                  "Access-Control-Allow-Origin": '*',
                  "Authorization": "Bearer " + localStorage.getItem("tkn"),
                  'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                  "Cache-Control": "no-cache"
              },
              dataType: 'json',
              success: function (data) {
                  self.loading = false ;
                  if (data.status == 'success'){
                      var link = document.createElement('a');
                      document.body.appendChild(link);
                      link.href = data.content;
                      link.download = '';
                      link.target = "_blank";
                      link.click();
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'vehicle-registration-form-download');
              }
          });

      },
      previewForm() {
        var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/vehicle-registration/preview/"+self.vehicle_registration_id,
        type: "GET",
        crossDomain: true,
        headers: {
          'Accept': 'application/json',
          "Access-Control-Allow-Origin": '*',
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
          "Cache-Control": "no-cache"
        },
        data: {
          orderType:0,
          class:0,
          batterySize:0,
          wheelbase:0,
          addPto:0,
          addExtendedWarranty:0,
          highVoltageBattery:0,
          powerTrain:0,
          hvee:0,
          allBundle:0,
          deliveryArea:0,
          colorWhite:0,
          vehiclePrice:0,
          deliveryFee:0,
          warrantyFee:0
        },
        success: function (data) {
          self.loading = false;
          setTimeout(function () {
            $("#vehicle_registration_content").html(data);
          }, 300);

        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'rental-invoice-preview');
        }
      });
      },
      print() {
          var self = this;
          self.loading = true;
          var content = document.getElementById('vehicle_registration_content').innerHTML;
          console.log(content);
          var link = window.open(content, '_blank');
          link.document.write(content);
          link.document.close();
          self.loading = false;
          link.print();
          link.close();

      }

  }
}
</script>




// WEBPACK FOOTER //
// src/components/VehicleRegistrationFormPreview.vue